import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BasicCheckbox } from 'core/components';

function ConfirmingReportItemValidationsModalTemplate({ confirmingReportItemValidationsModalViewStore, t }) {
    const {
        modalParams,
        confirmingReportItemValidations,
        updateValidations,
        onChange,
        salesOrderNumber,
        brightreeBaseUrl,
        patientFullName
    } = confirmingReportItemValidationsModalViewStore;
    return (
    <section>
          <div className="modal__header">
                <h3 className='modal__header__title'>
                    Validations - SO: {salesOrderNumber ? 
                                        <a target='_blank' href={brightreeBaseUrl + 'OrderEntry/frmSOOrderRO.aspx?SalesOrderKey=' + salesOrderNumber + '&ShowAck=0&Edit=0'}>
                                            {salesOrderNumber}
                                        </a>                                             
                                            : 'N/A'} 
                                - Patient: {patientFullName}
                </h3>
            </div>
            <div className="row">
                <div className='col col-lrg-12 u-mar--bottom--sml'>
                             
                    <table className="table--preview">
                        <thead>
                            <tr>
                                <th className="type--left">Item Id</th>
                                <th className="type--left">Validation</th>
                                <th className="type--left">Notes</th>
                                <th className="type--left">Is Resolved</th>
                                <th className="type--left">Resolved By User</th>
                                <th className="type--left">Date Resolved</th>
                            </tr>
                        </thead>
                        <tbody>
                            { confirmingReportItemValidations && confirmingReportItemValidations.map(itemValidation => {
                                return (
                                <tr key={itemValidation.id}>
                                    <td>{ itemValidation.itemId }</td>
                                    <td>{ itemValidation.validation.name }</td>
                                    <td>{ itemValidation.notes }</td>
                                    <td>
                                        <BasicCheckbox id={itemValidation.id} checked={itemValidation.isResolved} onChange={() => onChange(itemValidation)} />
                                    </td>
                                    <td>{ itemValidation.coreUser && itemValidation.coreUser.fullName }</td>
                                    <td>{ itemValidation.dateResolved }</td>
                                </tr>);
                            })}
                        </tbody>
                    </table>         
                </div>
                <div className='col col-lrg-12'>
                    <BaasicButton
                        className="btn btn--base btn--primary u-mar--right--sml"
                        label='Save'
                        onClick={() => updateValidations()}
                        disabled={confirmingReportItemValidations.length === 0}
                        >  
                    </BaasicButton> 
                    <BaasicButton
                        className='btn btn--base btn--ghost'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => modalParams.close()}
                    />
                </div>

            </div>
        </section>
    )
}

ConfirmingReportItemValidationsModalTemplate.propTypes = {
    confirmingReportItemValidationsModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ConfirmingReportItemValidationsModalTemplate);
